import React from 'react';
import { partners } from './constants';
import styles from './Partners.module.css';
import catalogStyles from './Catalog.module.css';
import { Link } from 'react-router';

export default function Partners() {
    return (
        <section className={styles.partnersSection}>
            <div className={styles.container}>
                <div className={styles.header}>
                    <h2 className={styles.title}>Content Partners</h2>
                    <p className={styles.subtitle}>Collaborating with the best to bring you quality VR education.</p>
                </div>
                <div className={styles.logoGrid}>
                    {partners.map((partner) => (
                        <Link to={partner.url || ''}>
                            <img
                                key={partner.name}
                                className={styles.logo + " " + catalogStyles.catalogCard}
                                src={partner.logo}
                                alt={partner.name}
                                referrerPolicy="no-referrer"
                            />
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
}